import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const Invite = ({
  title = "Brief us. Don't waste another quarter optimising vanity.",
  text = "Tell us where the spend is — and what you think it's getting you. We respond within one business day with an honest read."
}) => (
  <section className="invite">
    <div className="shell">
      <div className="layout">
        <div>
          <span className="tag tag--orange">BRIEF US</span>
          <h2 style={{ marginTop: "1.25rem" }}>{title}</h2>
          <p>{text}</p>
        </div>
        <div className="actions">
          <Link to="/contact" className="btn btn--orange">
            Send a brief <FiArrowRight />
          </Link>
          <Link to="/services" className="btn btn--ghost-light">All services</Link>
        </div>
      </div>
    </div>
  </section>
);

export default Invite;
